import { Component, OnInit } from '@angular/core';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { QrAfiliadoComponent } from '../qr-afiliado/qr-afiliado.component';
import { ShareService } from 'src/app/services/share.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-qr-profile',
  templateUrl: './qr-profile.component.html',
  styleUrls: ['./qr-profile.component.scss'],
})
export class QrProfileComponent implements OnInit {
  constructor(
    private uiSv: UiServices,
    private shareSv: ShareService,
    private loginSv: LoginService
  ) {}

  ngOnInit() {}

  async share(type: 'qr' | 'link') {
    const registerLink = `${environment.webSiteUrl}/auth?ref=register`;
    if (type === 'link') {
      await this.shareSv.share(
        '',
        `&code=${this.loginSv.user.code}`,
        registerLink
      );
      this.uiSv.showToast('Enlace copiado al portapapeles');
    } else {
      await this.uiSv.showModal(
        QrAfiliadoComponent,
        {
          uri: registerLink,
          title: type === 'qr' ? 'Código QR' : 'Enlace de registro',
          type,
        },
        'qrAff'
      );
    }
  }
}
